import script from "./high-end-class_back.vue?vue&type=script&setup=true&lang=js"
export * from "./high-end-class_back.vue?vue&type=script&setup=true&lang=js"

import "./high-end-class_back.vue?vue&type=style&index=0&id=4244a36a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4244a36a"]])

export default __exports__